import { CallbackObject } from 'api/core/get-page-function';
import { instance } from 'api/core';

export interface RegisterStationBody {
  stationId: string;
  warehouseId: string;
  serverId: string;
  externalId?: string;
}

export const registerStation = async (body: RegisterStationBody, callback: CallbackObject<void>) => {
  try {
    await instance.post(`/asrs/stations`, body);
    callback.success();
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
